import { Texture, Vec2, Rectangle } from 'lbs-pi-webgl-renderer-dev';
import { TileImage } from './TileImage';

export class Chunk {
  constructor (x, y, w, h, tw, th, renderer) {
    this.tiles = [];
    this.allTiles = [];
    this.renderer = renderer;
    this.x = x;
    this.y = y;
    this.w = w;
    this.h = h;
    this.tw = tw;
    this.th = th;
    this.visible = true;
    this.chunkSprite = renderer.createSprite();
    this.chunkTexture = null;

    // This rect is used to handle putting tiles in the proper place in this (unresized) chunk this is "true-size"
    this.rect = new Rectangle(x * w, y * h, w, h);

    // This rect is used to detect if this (resized) chunk is in-view
    this.viewRect = new Rectangle(x * w, y * h, w, h);
  }

  update (scale) {
    if (scale > 1) {
      this.chunkSprite.useLinear = ((scale % 1) === 0) ? 0 : 1;
    } else {
      this.chunkSprite.useLinear = 0;
    }

    this.viewRect.left = this.rect.left * scale;
    this.viewRect.top = this.rect.top * scale;
    this.viewRect.width = this.rect.width * scale;
    this.viewRect.height = this.rect.height * scale;

    if (this.visible) {
      this.chunkSprite.transform.position = new Vec2((this.rect.left * scale), (this.rect.top * scale));
      this.chunkSprite.transform.scale = new Vec2(this.w * scale, this.h * scale);
    }
  }

  draw () {
    if (this.visible) {
      this.chunkSprite.draw(this.renderer.camera);
      this.allTiles.forEach((tile) => tile.draw(this.renderer.camera));
    }
  }

  unloadChunk () {
    this.allTiles.forEach(t => t.unloadTexture());

    if (this.chunkTexture) {
      this.chunkTexture.dispose();
      this.chunkTexture = null;
    }

    this.tiles = [];
    this.allTiles = [];
  }

  createTile (x, y, requestQueue, zoom) {
    if (!this.tiles[x]) {
      this.tiles[x] = [];
    }

    if (!this.tiles[x][y]) {
      if (!this.chunkTexture) {
        this.chunkTexture = Texture.create(this.w, this.h, this.renderer);
        this.chunkSprite.setTexture(this.chunkTexture);
      }

      let mapped = this.rect.mapPoint(x * this.tw, y * this.th);
      const tile = new TileImage(x, y, this.tw, this.th, mapped.x, mapped.y, zoom, this.chunkTexture, requestQueue);
      this.allTiles.push(tile);
      this.tiles[x][y] = tile;
    }
  }
}
